import { Title, Button } from "@vshp/ui-components";
import programDisciplinesBg from "../../../public/images/disciplines.jpg";
import Slider from "../utils/Slider";
import Image from "next/image";

const ProgramDisciplines = ({ disciplines, planUrl }) => {
  return (
    <section className="page__block page__block_cover page__block_center page__block_no_space_bottom">
      <Image className="page__block-img" src={programDisciplinesBg} alt="ДИСЦИПЛИНЫ" placeholder="blur" />
      <div className="page__block-body">
        <Title type="h2" decor={false}>
          ДИСЦИПЛИНЫ
        </Title>

        <Slider className="slider-disciplines">
          {disciplines.map(({ title, content }, key) => (
            <div className="slider__item" key={key}>
              <div className="slider-disciplines__item">
                <div className="slider-disciplines__name t-h3">{title}</div>
                <div className="slider-disciplines__text wysiwyg">
                  <p>{content}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        {planUrl !== null && (
          <Button className="page__block-btn" spaceTop={true} href={planUrl} target="_blank" rel="noopener noreferrer">
            Скачать весь учебный план
          </Button>
        )}
      </div>
    </section>
  );
};

export default ProgramDisciplines;
